import { RatePlan, RatePlanType } from "./RatePlans";
import { AccountHolderRatePlan } from "../../services/accountService";
import RatePlanList from "./RatePlanList";
import MonthlyFee from "./MonthlyFee";

type Props = {
  accountHolderCode: string;
  accountHolderId: string;
  accountHolderRatePlans: AccountHolderRatePlan[];
  useInterchangeRate: boolean;
  hasMonthlyFee: boolean;
  monthlyFee: string;
  ratePlanType: RatePlanType;
  isLoading: boolean;
  isEditing: boolean;
};

function InterchangePlusPlan({
  accountHolderCode,
  accountHolderId,
  accountHolderRatePlans,
  useInterchangeRate,
  hasMonthlyFee,
  monthlyFee,
  ratePlanType,
  isLoading,
  isEditing,
}: Props): JSX.Element {
  return (
    <div className="flex w-full flex-col flex-wrap">
      <RatePlanList
        accountHolderCode={accountHolderCode}
        accountHolderId={accountHolderId}
        accountHolderRatePlans={accountHolderRatePlans}
        ratePlanType={ratePlanType}
        isLoading={isLoading}
        isEditing={isEditing}
      />
      <MonthlyFee
        accountHolderCode={accountHolderCode}
        accountHolderId={accountHolderId}
        hasMonthlyFee={hasMonthlyFee}
        monthlyFee={monthlyFee}
      />
    </div>
  );
}

export default InterchangePlusPlan;
